import { IOrderSale } from '../../order-sale-form';

export const PRODUCT_LOCKED_BY_RETURNS_MESSAGE =
    'Este producto tiene devoluciones: elimina la devolución primero';

// A saved sale line whose product has returns can be neither deleted nor
// switched to another product — either would leave the returns pointing at a
// product the sale no longer has (the backend rejects both). Only saved lines
// (with an id) are locked: a freshly added row that happens to pick the same
// product is a duplicate the user must still be able to change or delete.
export function isProductLockedByReturns(
    orderSaleProduct: IOrderSale['order_sale_products'][number] | undefined,
    orderAdjustmentProducts: IOrderSale['order_adjustment_products'],
): boolean {
    if (!orderSaleProduct?.id || !orderSaleProduct.product) {
        return false;
    }
    const productId = orderSaleProduct.product.id;
    return !!orderAdjustmentProducts?.some(
        (oap) => oap.product_id === productId,
    );
}
